import { useState } from "react";
import { Palette, Check } from "@phosphor-icons/react";

// 10 curated colors — enough variety without being overwhelming
const PALETTE = [
  { hex: "#005CFF", name: "Bleu" },
  { hex: "#8B5CF6", name: "Violet" },
  { hex: "#10B981", name: "Vert" },
  { hex: "#F59E0B", name: "Ambre" },
  { hex: "#F97316", name: "Orange" },
  { hex: "#EF4444", name: "Rouge" },
  { hex: "#EC4899", name: "Rose" },
  { hex: "#06B6D4", name: "Cyan" },
  { hex: "#84CC16", name: "Citron" },
  { hex: "#94A3B8", name: "Ardoise" },
];

/**
 * Compact color picker — dot swatches. Click to select, click active to clear.
 * Also accepts free hex via a tiny input for advanced users.
 */
export default function ColorPickerField({ value, onChange, testid = "color-picker", label = "Couleur" }) {
  const [showCustom, setShowCustom] = useState(false);
  const active = (value || "").toLowerCase();

  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="flex items-center gap-1.5 text-white/60 text-[10px] uppercase tracking-widest">
        <Palette size={11} weight="duotone" /> {label}
        {active && (
          <button
            type="button"
            onClick={() => onChange(null)}
            className="ml-auto text-[9px] text-white/40 hover:text-white/70 normal-case tracking-normal"
            data-testid={`${testid}-clear`}
          >
            effacer
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {PALETTE.map((c) => {
          const on = active === c.hex.toLowerCase();
          return (
            <button
              key={c.hex}
              type="button"
              onClick={() => onChange(c.hex)}
              title={c.name}
              className={`relative w-7 h-7 rounded-full transition-transform hover:scale-110 active:scale-95 ${on ? "ring-2 ring-white ring-offset-2 ring-offset-[#111]" : ""}`}
              style={{ background: c.hex }}
              data-testid={`${testid}-${c.hex.slice(1)}`}
            >
              {on && <Check size={12} weight="bold" className="absolute inset-0 m-auto text-white drop-shadow" />}
            </button>
          );
        })}
        <button
          type="button"
          onClick={() => setShowCustom((s) => !s)}
          className="w-7 h-7 rounded-full border border-dashed border-white/25 text-white/50 flex items-center justify-center hover:border-white/50 text-[10px]"
          title="Couleur perso"
          data-testid={`${testid}-custom`}
        >
          #
        </button>
      </div>
      {showCustom && (
        <input
          type="color"
          value={active || "#005CFF"}
          onChange={(e) => onChange(e.target.value)}
          className="w-full h-8 rounded-lg bg-white/5 border border-white/10 cursor-pointer"
          data-testid={`${testid}-native`}
        />
      )}
    </div>
  );
}
